export default __webpack_public_path__ + "static/media/detailing.39c335eb.jpg";